import axios from "axios"

export const API_CONTACT_FORM_SUBMIT = (name, email, phone, message) =>
  axios({
    url: `${process.env.GATSBY_SERVER_URL}/submitNewContactForm`,
    method: "POST",
    headers: {
      "api-key": process.env.GATSBY_SERVER_API_KEY,
    },
    data: {
      name: name,
      email: email,
      phone: phone,
      message: message,
    },
  })

export const API_QUOTE_FORM_SUBMIT = (
  name,
  email,
  company,
  projectTitle,
  projectDescription,
  completionTime
) =>
  axios({
    url: `${process.env.GATSBY_SERVER_URL}/submitNewQuoteRequestForm`,
    method: "POST",
    headers: {
      "api-key": process.env.GATSBY_SERVER_API_KEY,
    },
    data: {
      name: name,
      email: email,
      company: company,
      projectTitle: projectTitle,
      projectDescription: projectDescription,
      projectCompletionTime: completionTime,
    },
  })

export const API_WP_GET_ALL_POSTS = () =>
  axios({
    url: `${process.env.GATSBY_BLOG_SERVER_URL}/posts`,
    method: "GET",
  })

export const API_WP_GET_POST_BY_ID = id =>
  axios({
    url: `${process.env.GATSBY_BLOG_SERVER_URL}/posts/${id}`,
    method: "GET",
  })
